import React from 'react';
import pluralize from 'pluralize';
import { Folder } from '../../types';
import { formatFileSize } from '../../utils/formatters';
import EntityHeader from '../ui/EntityHeader';

interface FolderHeaderProps {
  folder: Folder;
}

const FolderHeader: React.FC<FolderHeaderProps> = ({ folder }) => {
  const metadata = [
    {
      label: 'File Count',
      value: pluralize('file', folder.fileCount || 0, true),
    },
    {
      label: 'Total Size',
      value: formatFileSize(folder.totalSize || 0),
      show: (folder.totalSize || 0) > 0,
    },
    {
      label: 'Created',
      value: new Date(folder.createdAt).toLocaleDateString(),
    },
  ];

  return (
    <EntityHeader
      title={folder.name}
      statusVariant="folder"
      statusText="Folder"
      metadata={metadata}
    />
  );
};

export default FolderHeader;
